import React from 'react'
import ffffff from '../image/ffffff.avif'
import { styled } from '@mui/system'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import Typography from '@mui/material/Typography'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
const useStyles = styled((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}))

function Java_FAQ_page() {
  return (
    <div>
      <div className="mt-5">
        <div className="container pt-3">
          <div className="text-center Curriculum_Main_text">
            <div className="">
              <h2 className="display-6">Frequently Asked Questions</h2>
              <p className="pt-2">
                Our Responses to Your Inquiries: Unblocking the Way to Clarity
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-5">
              <div className="FAQ_img">
                <img
                  src={ffffff}
                  onContextMenu={(e) => e.preventDefault()}
                ></img>
              </div>
            </div>
            <div className="col-md-7 pt-5 d-none d-md-block">
              <div className="pt-5">
                <div className="pt-5">
                  <div className="pt-5">
                    <Java_FAQ />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-7 d-sm-block d-md-none mb-5">
              <Java_FAQ />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

function Java_FAQ() {
  const classes = useStyles()
  const [expanded, setExpanded] = React.useState(false)

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false)
  }

  return (
    <div className={classes.root}>
      <Accordion
        className="py-2"
        expanded={expanded === 'panel1'}
        onChange={handleChange('panel1')}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
          className="FAQ_background_color"
        >
          <Typography style={{ fontSize: '1.2rem' }}>
            What skills should a Java developer have?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            <ul>
              <li>
                Core Java: Strong understanding of OOP concepts, data
                structures, multithreading, and exception handling.
              </li>
              <li>
                Java Frameworks: Familiarity with Spring, Hibernate, and Java EE
                is often expected.
              </li>
              <li>
                Databases: Knowledge of SQL and working with databases like
                MySQL, Oracle, or MongoDB.
              </li>
              <li>
                Tools: Experience with tools like Maven, Jenkins, Git, and
                Docker.
              </li>
              <li>
                Problem-Solving: Ability to write efficient algorithms and solve
                real-world problems.
              </li>
            </ul>
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        className="py-2"
        expanded={expanded === 'panel2'}
        onChange={handleChange('panel2')}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2bh-content"
          id="panel2bh-header"
          className="FAQ_background_color"
        >
          <Typography style={{ fontSize: '1.2rem' }}>
            What are the career prospects for a Java developer?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            Java remains one of the most widely used programming languages,
            especially in large-scale enterprise applications. Career prospects
            include roles like:
            <ul>
              <li>Java Developer, Full-Stack Developer</li>
              <li>DevOps Engineer, Software Architect</li>
              <li>Cloud-based Java Developer</li>
            </ul>
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        className="py-2"
        expanded={expanded === 'panel3'}
        onChange={handleChange('panel3')}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3bh-content"
          id="panel3bh-header"
          className="FAQ_background_color"
        >
          <Typography style={{ fontSize: '1.2rem' }}>
            How can I advance my career as a Java developer?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            <ul>
              <li>
                Keep Learning: Stay updated with the latest Java versions,
                frameworks, and tools.
              </li>
              <li>
                Contribute to Open Source: Contributing to open-source projects
                can enhance your visibility in the developer community.
              </li>
              <li>
                Certifications: Obtaining certifications like Oracle Certified
                Professional Java Programmer (OCPJP) can boost your credibility.
              </li>
              <li>
                Explore New Technologies: Gain skills in cloud platforms (AWS,
                Azure), microservices, and DevOps.
              </li>
            </ul>
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        className="py-2"
        expanded={expanded === 'panel4'}
        onChange={handleChange('panel4')}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel4bh-content"
          id="panel4bh-header"
          className="FAQ_background_color"
        >
          <Typography style={{ fontSize: '1.2rem' }}>
            What are common Java developer interview questions?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            <ul>
              <li>
                Core Concepts: What are the main features of Java 8? How does
                garbage collection work in Java?
              </li>
              <li>
                Frameworks: Explain the Spring framework’s dependency injection
                mechanism.
              </li>
              <li>
                Problem-Solving: Write code to find the second largest number in
                an array.
              </li>
              <li>
                Design Patterns: Explain Singleton and Factory patterns in Java.
              </li>
              <li>
                Multithreading: How do you create threads in Java? What are race
                conditions?
              </li>
            </ul>
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        className="py-2"
        expanded={expanded === 'panel5'}
        onChange={handleChange('panel5')}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel5bh-content"
          id="panel5bh-header"
          className="FAQ_background_color"
        >
          <Typography style={{ fontSize: '1.2rem' }}>
            Is learning Java still relevant in 2024 and beyond?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            Yes, Java is still highly relevant, especially in enterprise
            environments, Android development, and backend systems. Java's
            ecosystem, large community, continuous updates, and widespread use
            ensure it remains a crucial language for the foreseeable future.
          </Typography>
        </AccordionDetails>
      </Accordion>
    </div>
  )
}

export default Java_FAQ_page
